export default __webpack_public_path__ + "static/media/Vetted.48203d5f.svg";